<ion-header [translucent]="true">
  <ion-toolbar class="ion-text-center">
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>NAAC Metric - {{metricId}}</ion-title>
    <ion-buttons slot="end">
      <ion-button fill="clear" (click)="closeModal()"><ion-icon name="close"></ion-icon></ion-button>
      <div class="college-logo-container" *ngIf="showCollegeLogo && collegeLogo">
        <img [src]="collegeLogo" alt="College Logo" class="college-logo-image" />
      </div>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="segment-label">
    <div class="container" *ngIf="selected">
        <div class="row bg-info text-white">
            <div class="col"><strong>Institution:</strong> {{institution}}</div>
        </div>
        <div class="row bg-brand-light-gr">
            <div class="col"><strong> Metric No:</strong>  {{metricId}}</div>
            <div class="col"><strong> Metric Type:</strong>  QnM</div>
            <div class="col"><strong> Weightage:</strong>  {{selected.weight }}</div>
        </div>
        <!-- Description -->
        <div class="row bg-brand-light-info">
            <div class="col">
                <strong>Description:</strong>
                <div [innerHTML]="selected.desc" class="description-content"></div>
            </div>
        </div>
        <!-- Documents Needed -->
        <div class="row bg-brand-light-warning" *ngIf="selected !== undefined && selected.documentList && selected.documentList.length > 0">
            <div class="col-12">
                <strong>Documents Needed / Upload Documents:</strong>
                <div class="documents-list">
                    <div *ngFor="let metrics of selected.documentList" class="document-item">
                        <div *ngFor="let docList of metrics.list" [innerHTML]="docList" class="doc-list-item"></div>
                    </div>
                </div>
            </div>
        </div>

        <!-- Web-links -->
        <div class="row bg-brand-light-gr" *ngIf="selected !== undefined && selected.documentList && selected.documentList.length > 0">
            <div class="col-12">
                <strong>Web-links:</strong>
                <div class="weblinks-list">
                    <div *ngFor="let metrics of selected.documentList" class="weblink-item">
                        <div *ngIf="metrics.weblink" [innerHTML]="metrics.weblink" class="weblink-content"></div>
                        <div *ngIf="!metrics.weblink" class="no-weblink">Not mandatory, but desirable</div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Specific Instructions -->
        <div class="row bg-brand-light-info">
            <div class="col-12">
                <strong>Specific Instructions to HEIs:</strong>
                <ol *ngIf="selected.instructions && selected.instructions.length > 0 && !(selected.instructions.length === 1 && (selected.instructions[0] === '--' || selected.instructions[0] === '-'))">
                    <li *ngFor="let list of selected.instructions" [innerHTML]="list"></li>
                </ol>
                <div *ngIf="!selected.instructions || selected.instructions.length === 0 || (selected.instructions.length === 1 && (selected.instructions[0] === '--' || selected.instructions[0] === '-'))" class="not-applicable">
                    Not applicable
                </div>
            </div>
        </div>

        <div class="row bg-dark">
            <div class="col-12 text-white">
                <strong>Not to be Included /Considered:</strong>
                <ol *ngIf="selected.notincluded && selected.notincluded.length > 0 && !(selected.notincluded.length === 1 && (selected.notincluded[0] === '--' || selected.notincluded[0] === '-'))">
                    <li *ngFor="let list of selected.notincluded" [innerHTML]="list"></li>
                </ol>
                <div *ngIf="!selected.notincluded || selected.notincluded.length === 0 || (selected.notincluded.length === 1 && (selected.notincluded[0] === '--' || selected.notincluded[0] === '-'))" class="not-applicable">
                    Not applicable
                </div>
            </div>
        </div>
    </div>

</ion-content>

